import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetFinanceQcAction } from "../../../redux/actions/PayoutAction";
import { TotalProveiderMonth } from "../PayOut/helper";
import Modal from "react-modal";
import { FinanceQCPopupEditDiscount } from "./FinanceQCPopupEditDiscount";
export const FinanceQcPopup = ({
  rowData,
  searchFilter,
  setRowData,
  setQcFinancePage,
  reCallApi,
  setReCallApi,
  payableData,
  setPayabelData,
  firstPageData,
  setSearchFilter
  
}) => {
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const [isEdit, setIsEdit] = useState({ open: false });

  useEffect(() => {
    if (reCallApi === true) {
      dispatch(
        GetFinanceQcAction({
          ...searchFilter,
          page:globalReducer?.getCurrentPage,
          sessionId: rowData?.sessionID,
          ticketId: rowData?.requestID,
          providerId: rowData?.providerId,
        })
      );
    } else {
      dispatch(
        GetFinanceQcAction({
          ...searchFilter,
          sessionId: firstPageData?.sessionID,
          ticketId: firstPageData?.requestID,
          providerId: firstPageData?.providerId,
        })
      );
    }
  }, [globalReducer?.getCurrentPage]);

  return (
    <>
      <div className="table-responsive __custom__properties pt-2">
        <div style={{ overflowX: "auto", maxWidth: "100%" }}>
          <table className="table">
            <thead>
              <tr className="avanishtbl">
                <th>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={
                      payoutReducer?.getFinanceQc?.length ===
                      payableData?.length
                    }
                    onChange={(e) => {
                      e.target.checked
                        ? setPayabelData(payoutReducer?.getFinanceQc)
                        : setPayabelData([]);
                    }}
                    readOnly
                  />
                </th>
                <th className="tabelHeader">Provider ID/Name</th>
                <th className="tabelHeader" style={{ textAlign: "center" }}>
                  Month
                </th>
                <th className="tabelHeader" style={{ textAlign: "center" }}>
                  Provider Amount
                </th>
                <th className="tabelHeader" style={{ textAlign: "center" }}>
                  MBG
                </th>
                <th className="tabelHeader" style={{ textAlign: "center" }}>
                  MIS
                </th>
                <th className="tabelHeader" style={{ textAlign: "center" }}>
                  Provider Disc
                </th>
                <th className="tabelHeader" style={{ textAlign: "center" }}>
                  Apt Disc
                </th>
                <th className="tabelHeader" style={{ textAlign: "center" }}>
                  Net Amount
                </th>
                <th className="tabelHeader" style={{ textAlign: "center" }}>
                  Appointment
                </th>
                <th className="tabelHeader">Request Status</th>
                <th className="tabelHeader">Updated By</th>
                <th className="tabelHeader">Action</th>
              </tr>
            </thead>
            <tbody>
              {payoutReducer?.getFinanceQc?.map((ele, index) => {
                return (
                  <tr key={ele?.clientId}>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        // disabled={ele?.requestStatus !== "Pending At Finance" && ele?.requestStatus !== "Partial QC" && ele?.requestStatus !== "Partial Finance"  }
                        checked={payableData?.some(
                          (item) => item?.requestID === ele?.requestID
                        )}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setPayabelData([...payableData, ele]);
                          } else {
                            let arr = payableData.filter(
                              (item) => item !== ele
                            );
                            setPayabelData(arr);
                          }
                        }}
                        readOnly
                      />
                    </td>
                    <td>
                      <a
                        className="text-highlighted text-decoration"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setRowData(ele);
                          setQcFinancePage("secondPage");
                          setReCallApi(false);
                          setPayabelData([]);
                          setSearchFilter({
                            ...searchFilter,
                            providerName: "",
                            requestStatus: "",
                          });
                        }}
                      >
                        {ele?.providerName}
                      </a>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {TotalProveiderMonth(ele?.year, ele?.month)}
                    </td>
                    <td style={{ textAlign: "center" }}>{ele?.totalAmount}</td>
                    <td style={{ textAlign: "center" }}>{ele?.mbg}</td>
                    <td style={{ textAlign: "center" }}>{ele?.mis}</td>
                    <td style={{ textAlign: "center" }}>{ele?.discountedAmount}</td>
                    <td style={{ textAlign: "center" }}>{ele?.appointmentsDiscount}</td>
                    <td style={{ textAlign: "center" }}>{ele?.netAmount}</td>
                    <td style={{ textAlign: "center" }}>
                      {ele?.requestedAppointment}
                    </td>
                    <td>
                      <p
                        style={{ margin: "auto" }}
                        className={` status-style ${
                          ele?.requestStatus === "Paid"
                            ? "approved"
                            : ele?.requestStatus === "Reject By Finance" ||
                              ele?.requestStatus === "Not Paid "
                            ? "rejected"
                            : ele?.requestStatus === "Pending At Finance" ||
                              ele?.requestStatus === "Pending at Network"
                            ? "pendingAtFinance"
                            : ele?.requestStatus === "Pending For Payment"
                            ? "pendingForpayment"
                            : ele?.requestStatus === "Pending For Provider"
                            ? "refundStatus"
                            : ele?.requestStatus === "Rejected By Provider"
                            ? "rejected"
                            : "pending"
                        }`}
                      >
                        {ele?.requestStatus}
                      </p>
                    </td>
                    <td>{ele?.updatedBy}</td>
                    {ele?.requestStatus === "Pending At Finance" && (
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setIsEdit({ data: ele, open: true });
                          console.log("ele Data", ele);
                        }}
                      >
                        <img src="./images/edit-icon.png" alt="" />
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div
          class="modal fade"
          id="additinalFinanceAppHeader"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <Modal
            isOpen={isEdit.open}
            className="modal-add-user-popup modal-upload-excel-popup"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <FinanceQCPopupEditDiscount
              setIsEdit={setIsEdit}
              isEdit={isEdit}
              searchFilter={searchFilter}
              setPayabelData={setPayabelData}
              reCallApi={reCallApi}
              setReCallApi={setReCallApi}
              rowData={rowData}
              setRowData={setRowData}
              firstPageData={firstPageData}
            />
          </Modal>
        </div>
      </div>
    </>
  );
};
